define('home/views/DiscussionPageChannelInfoView',[
    'backbone-marionette',

    'home/mixins/withChannelAvatar',
    'core/mixins/withChannelFollowing',
    'home/mixins/withCollapsing',
    'home/templates/discussionPageChannelInfo',
], function (
    Marionette,

    withChannelAvatar,
    withChannelFollowing,
    withCollapsing,
    discussionPageChannelInfo
) {
    'use strict';

    /**
     * View shows the channel info and a follow button
     *
     * Expects a Channel model for model and the router instance in options.app.
     */
    var DiscussionPageChannelInfoView = Marionette.ItemView.extend({
        template: discussionPageChannelInfo,

        templateHelpers: function () {
            var primaryForum = this.model.primaryForum;
            var numThreads = primaryForum.get('numThreads');
            var numFollowers = primaryForum.get('numFollowers');

            return {
                // Attributes may be null during fetch
                numThreads: numThreads && numThreads.toLocaleString(),
                numFollowers: numFollowers && numFollowers.toLocaleString(),
                previouslyFollowing: this.previouslyFollowing,
            };
        },

        initialize: function (options) {
            this.app = options.app;
            this.session = options.session;
            this.previouslyFollowing = this.getIsFollowing();
            this.bindToPrimaryForum();

            // toggled:follow event is triggered by the withChannelFollowing
            // mixin when a user clicks on the follow button. Rerender to update
            // the onboarding message.
            this.listenTo(this, 'toggled:follow', this.render);
        },

        bindToPrimaryForum: function () {
            if (!this.model.primaryForum) {
                this.listenToOnce(this.model, 'changeRelated:primaryForum', this.bindToPrimaryForum);
                return;
            }

            this.listenTo(this.model.primaryForum,
                'change:numFollowers change:numThreads',
                this.render);
        },

    });

    withChannelFollowing.call(DiscussionPageChannelInfoView.prototype, function () {
        return this.model;
    });

    withChannelAvatar.call(DiscussionPageChannelInfoView.prototype, function () {
        return this.model;
    });

    withCollapsing.call(DiscussionPageChannelInfoView.prototype, {
        maxHeight: 200, // px
        collapsibleSelector: '[data-role=guidelines-section]',
    });

    return DiscussionPageChannelInfoView;
});


